<template>
  <div id="sovdetail">
    <div data-html2canvas-ignore="true" v-show="loader || loaderStatus">
      <Loader />
    </div>
    <div class="datepickerwrap card revampCard mb-3 d-flex justify-content-between flex-wrap"
      style="flex-direction: row">
      <div class="d-flex align-items-center flex-wrap" style="gap: 5px">
        <div class="" style="margin-top: 0.2rem">
          <div style="
              font-size: 13px;
              font-weight: 400;
              color: #1e1e1e;
              margin-bottom: 0.29rem;
            ">
            {{ translatedLang["Date"][selectedLanguage.key] }}
          </div>
          <date-range-picker v-model="dateRange" opens="right" :autoApply="true"
            :locale-data="{ format: 'dd mmm yyyy' }" :show-dropdowns="true" :min-date="minDate"
            :single-date-picker="true" :max-date="maxDate">
            <!-- @update="changeCustomDate" -->
          </date-range-picker>
        </div>
        <div class="customMultiselectCommon" style="min-width: 170px; max-width: 200px">
          <div class="mb-1 ml-1" style="font-size: 13px; font-weight: 400; color: #1e1e1e">
            {{ translatedLang["Platform"][selectedLanguage.key] }}
          </div>

          <!-- <select @change="refresh" v-model="selected_website" class="form-control text-capitalize">
            <option :value="website.platform_link" v-for="website of viewPlatformAndCategoryData.platform"
              :key="website.platform_name" class="text-capitalize">
              {{ website.platform_name.replace("_", " ") }}
            </option>
          </select> -->
          <multiselect @input="refresh" :custom-label="updateSelectedLabels" v-model="selected_website" :options="viewPlatformAndCategoryData.platform.filter(
            (items) =>
              viewPlatformAndCategoryData.category[items.platform_id]
          )
            " :multiple="false" :searchable="false" placeholder="Select Platform" label="platform_name"
            track-by="platform_link" :showLabels="false" :close-on-select="true" :allow-empty="false"
            class="text-capitalize">
            <template #option="{ option }">
              <div class="custom-option text-capitalize">
                {{ option.platform_name.replaceAll("_", " ") }}
              </div>
            </template>
          </multiselect>
        </div>
        <div class="customMultiselectCommon" style="width: 201px">
          <div class="mb-1 ml-1" style="font-size: 13px; font-weight: 400; color: #1e1e1e">
            {{ translatedLang["Category"][selectedLanguage.key] }}
          </div>
          <!-- @change="icChanged" -->
          <!-- <select v-model="selectedItemCategory" class="form-control text-capitalize">
            <option v-for="d in itemCategory" :value="d" :key="d.key" class="text-capitalize">
              {{ d.value }}
            </option>
          </select> -->
          <multiselect label="value" track-by="key" v-model="selectedItemCategory" class="text-capitalize"
            :options="itemCategory || []" :multiple="false" :searchable="false" placeholder="Select Category"
            :showLabels="false" :close-on-select="true" :allow-empty="false">
          </multiselect>
        </div>
        <div style="width: 160px; margin-top: 20px" class="ml-2">
          <!-- <div
            class="mb-1 ml-1"
            style="font-size: 13px; font-weight: 400; color: #1e1e1e"
          >
            Category
          </div> -->
          <button class="btn primarycolor" @click="applyFilter">
            {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
          </button>
        </div>
        <!-- <div class="customSelect dropdown-width">
          <button @click="filterApply" class="btn primarycolor">
              Apply Filters
            </button>
         
        </div> -->
        <!-- <div class="ml-lg-2 mt-3">
            <button @click="filterApply" class="btn primarycolor">
              Apply Filters
            </button>
          </div> -->
        <!-- <div class="customSelect" style="width: 170px">
          <div
            class="mb-1 ml-1"
            style="font-size: 13px; font-weight: 400; color: #1e1e1e"
          >
            Category/Se
          </div>
          <select
            @change="icChanged"
            v-model="dataType"
            class="form-control text-uppercase"
          >
            <option value="category">Category</option>
            <option value="search">Search</option>
          </select>
        </div> -->
        <!-- <div class="datebox" style="width: 10%">
          <button @click="icChanged" class="btn primarycolor" type="button">
            <span>Submit</span>
          </button>
        </div> -->
        <!-- <div class="datebox" style="width: 13%">
          <button @click="exportNow" class="ui button exportButton">Export</button>
        </div> -->
      </div>
      <div class="d-flex align-items-center mt-4 flex-wrap" style="gap: 10px">
        <!-- <div class="lastUpdated">
          Last Update : {{ lastUpdated }}
        </div> -->
        <div>
          <button @click="backToSov" style="width: max-content; float: right" class="navigationButton tw-flex tw-items-center tw-gap-2" type="button">
            <img src="Icons_SVG/Arrow_Left.svg" height="14" class="backIcon" />
            <span>{{ translatedLang["Back"][selectedLanguage.key] }} </span>
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div>
        <div class="card p-2 revampCard">
          <!-- <div class="d-flex justify-content-end align-items-center"> -->
          <!-- <div class="legending">
              <i
                class="fa fa-square"
                style="
                  color: var(--primary_client-20) !important;
                  border-radius: 2px;
                  margin-right: 2px;
                "
              ></i>
              <span style="text-transform: capitalize">{{ customClient }}</span>
            </div> -->
          <!-- <button @click="exportNow" class="ui button exportButton">Export</button> -->
          <!-- </div> -->
          <div class="mt-1" v-if="sovDetailtableDataShow">
            <table id="snapdeal-sovdetailedTable" class="table w-100">
              <thead class="thead-normal">
                <tr>
                  <th v-for="d in columns_details" :key="d.key" :class="{
                    'bigger-col': d.key === 'product_name',
                    'SmallBigger-col': d.key !== 'product_name',
                  }">
                    {{ d.label }}
                  </th>
                </tr>
              </thead>
              <tfoot style="display: table-row-group">
                <tr>
                  <th v-for="d in columns_details" :key="d.key">
                    {{ d.label }}
                  </th>
                </tr>
              </tfoot>
              <tbody class="tbody-normal">
                <tr v-for="(r, i) in rows_details" :key="i" :class="{ markitamd: r['brand'] == client }">
                  <td v-for="d in columns_details" :key="d.key" :class="{ 'text-capitalize': d.key === 'brand' }">
                    <span v-if="d.key == 'product_name'">
                      <a target="_blank" :href="r['link']">{{ r[d.key] }}</a>
                    </span>
                    <span v-else>
                      <span v-if="r[d.key] != ''">
                        <span>{{ r[d.key] }}</span>
                      </span>
                      <span v-else>-</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else-if="!sovDetailtableDataShow && loader" class="onLoadingData mt-0">
            {{ translatedLang["Loading"][selectedLanguage.key] }}...
          </div>
          <div v-else class="text-danger d-flex justify-content-center border border-danger rounded mt-1 p-2 noData">
            {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import sortedTable from "../../helpers/TableSort";
import Loader from "../Components/Loader.vue";
import Multiselect from "vue-multiselect";
import { mapState, mapActions } from "vuex";

export default {
  name: "sovdetail",
  components: { Datepicker, Multiselect, Loader },
  watch: {
    selected_website: function () {
      // let self = this;
      // if (self.selected_website == "https://www.flipkart.com") {
      //   self.itemCategory = [{ key: "womens kurtas", value: "Women's Kurtas" }];
      // } else {
      //   self.itemCategory = [{ key: "womens kurtas", value: "Women's Kurtas" }];
      // }
      // localStorage.demo_selected_website = this.selected_website;
    },
  },
  data: function () {
    return {
      selected_website: "",
      dateRange: {
        startDate: moment().subtract(1, "day").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      date: {
        pStartDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
        startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
        disabled: {
          pstart: {
            to: moment("2023-01-17", "YYYY-MM-DD").toDate(),
          },
          start: {
            to: moment("2023-01-17", "YYYY-MM-DD").toDate(),
          },
        },
      },
      // columns_details: [
      //   { label: "Rank", field: "order" },
      //   { label: "Page", field: "page" },
      //   { label: "translatedLang["Brand"][selectedLanguage.key]", field: "brand" },
      //   { label: "Name", field: "product_name", sortable: false },
      //   { label: "Original Price", field: "original_price", sortable: false },
      //   { label: "Discounted Price", field: "discount_price", sortable: false },
      //   { label: "Discount", field: "discount", sortable: false },
      //   { label: "Reviews", field: "reviews" },
      //   { label: "Ratings", field: "ratings" },
      // ],
      columns_details: [],
      rows: [],
      rows_details: [],
      page: 1,
      showAuditModal: false,
      columnsAudit: [
        { label: "SKU", field: "sku", sortable: false },
        {
          label: "Compliance Score",
          field: "compliance_score",
          sortable: false,
        },
        { label: "Position Score", field: "position_score", sortable: false },
        { label: "Rating Score", field: "rating_score", sortable: false },
        { label: "SKU Score", field: "sku_score", sortable: false },
      ],
      columns_category: [
        {
          label: "Category Position",
          field: "category_position",
          sortable: false,
        },
        {
          label: "Category page position (1-3)",
          field: "category_13_position",
          sortable: false,
        },
        { label: "Search Position", field: "search_position", sortable: false },
        {
          label: "Search (1-3) Position",
          field: "search_13_position",
          sortable: false,
        },
      ],
      columns_compliance: [
        { label: "Product Logo", field: "logo", sortable: false },
        { label: "OEM Images", field: "image_count", sortable: false },
        { label: "Nomenclature", field: "nomenclature", sortable: false },
        { label: "Message", field: "message", sortable: false },
      ],
      rowsAudit: [],
      isHero: false,
      rows_details_full: [],
      loader: false,
      itemCategory: [],
      selectedItemCategory: {},
      client: JSON.parse(localStorage.reviewUserData).data.client,
      dataType: "category",
      icChangeOccur: false,
      customClient: JSON.parse(localStorage.reviewUserData).data.client,
      viewPlatformAndCategoryData: JSON.parse(
        localStorage.viewPlatformAndCategoryData
      ),
      columnDefs: null,
      lastUpdated: `${moment().format("YYYY-MM-DD")} 11:00 AM`,
      storeAllDataForStatus: {},
      loaderStatus: false,
      // selectedPlatform: "",
      sovDetailtableDataShow: false,
    };
  },
  mounted() {
    let self = this;
    this.selected_website = this.viewPlatformAndCategoryData.platform[0];
    this.getlastUpdated();
    this.getCategoryList();
    // if(localStorage.philips_startDate) this.date.startDate = localStorage.philips_startDate
    // if(localStorage.philips_prevStartDate)  this.date.pStartDate = localStorage.philips_prevStartDate
    // if (localStorage.demo_selected_website)
    //   this.selected_website = localStorage.demo_selected_website;

    // if (self.selected_website == "https://www.flipkart.com") {
    //   self.itemCategory = [{ key: "womens kurtas", value: "Women's Kurtas" }];
    // } else {
    //   self.itemCategory = this.itemCategory;
    // }

    // if (localStorage.demo_selectedItemCategory) {
    //   this.selectedItemCategory = {};
    //   for (let [i, k] of this.itemCategory.entries()) {
    //     if (k.key == JSON.parse(localStorage.demo_selectedItemCategory).key) {
    //       this.selectedItemCategory = k;
    //     }
    //   }
    //   this.selected_website =
    //     this.viewPlatformAndCategoryData.platform[0].platform_link;

    //   if (!Object.keys(this.selectedItemCategory).length) {
    //     this.selectedItemCategory = this.itemCategory[0];
    //   }
    // } else self.selectedItemCategory = this.itemCategory[0];
    self.selectedItemCategory = this.itemCategory[0];
    this.initCols();
    // this.getAllStatusByApi();
  },
  watch: {
    selectedItemCategory: function () {
      if (Object.keys(this.storeAllDataForStatus).length) {
        this.$store.dispatch(
          "DemoStore/setUpdatedStatus",
          this.storeAllDataForStatus[this.selected_website.platform_id][
          this.selectedItemCategory.key
          ]
        );
      } else {
        this.$store.dispatch("DemoStore/setUpdatedStatus", "");
      }
    },
    dateRange: {
      handler() {
        this.getAllStatusByApi();
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
    getColumnsDetails() {
      return [
        { label: this.translatedLang["Rank"][this.selectedLanguage.key], field: "order" },
        { label: this.translatedLang["Page"][this.selectedLanguage.key], field: "page" },
        { label: this.translatedLang["Brand"][this.selectedLanguage.key], field: "brand" },
        { label: this.translatedLang["Name"][this.selectedLanguage.key], field: "product_name", sortable: false },
        { label: this.translatedLang["Original Price"][this.selectedLanguage.key], field: "original_price", sortable: false },
        { label: this.translatedLang["Discounted Price"][this.selectedLanguage.key], field: "discount_price", sortable: false },
        { label: this.translatedLang["Discount"][this.selectedLanguage.key], field: "discount", sortable: false },
        { label: this.translatedLang["Reviews"][this.selectedLanguage.key], field: "reviews" },
        { label: this.translatedLang["Ratings"][this.selectedLanguage.key], field: "ratings" }
      ];
    }
  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
    getlastUpdated() {
      if (localStorage.sov_last_update) {
        let sov_last_update = JSON.parse(localStorage.sov_last_update);
        if (this.selected_website.platform_id) {
          this.dateRange.endDate = sov_last_update[
            this.selected_website.platform_id
          ]
            ? moment(
              sov_last_update[this.selected_website.platform_id].end_date
            ).format("YYYY-MM-DD")
            : moment(sov_last_update.end_date).format("YYYY-MM-DD");
          this.dateRange.startDate = sov_last_update[
            this.selected_website.platform_id
          ]
            ? moment(
              sov_last_update[this.selected_website.platform_id].end_date
            ).format("YYYY-MM-DD")
            : moment(sov_last_update.end_date).format("YYYY-MM-DD");
          this.maxDate = sov_last_update[this.selected_website.platform_id]
            ? new Date(
              sov_last_update[this.selected_website.platform_id].end_date
            )
            : new Date(sov_last_update.end_date);
          this.minDate = sov_last_update[this.selected_website.platform_id]
            ? new Date(
              sov_last_update[this.selected_website.platform_id].start_date
            )
            : new Date(sov_last_update.start_date);
        } else {
          this.dateRange.endDate = moment(sov_last_update.end_date).format(
            "YYYY-MM-DD"
          );
          this.dateRange.startDate = moment(sov_last_update.end_date).format(
            "YYYY-MM-DD"
          );
          this.maxDate = new Date(sov_last_update.end_date);
          this.minDate = new Date(sov_last_update.start_date);
        }

        this.selected_website.platform_id
          ? (this.lastUpdated = `${sov_last_update[this.selected_website.platform_id]
            ? moment(
              sov_last_update[this.selected_website.platform_id]
                .end_date
            ).format("DD MMM, YYYY")
            : moment(sov_last_update.end_date).format("DD MMM, YYYY")
            } 
          ${sov_last_update[this.selected_website.platform_id]
              ? sov_last_update[this.selected_website.platform_id].latest_time
                ? "at"
                : ""
              : sov_last_update.latest_time
                ? "at"
                : ""
            } 
          ${sov_last_update[this.selected_website.platform_id]
              ? sov_last_update[this.selected_website.platform_id].latest_time
              : sov_last_update.latest_time
            }`)
          : (this.lastUpdated = `${moment(sov_last_update.end_date).format(
            "DD MMM, YYYY"
          )} ${sov_last_update.latest_time ? "at" : ""} 
          ${sov_last_update.latest_time}`);
        this.$store.dispatch("DemoStore/setTimeStamp", this.lastUpdated);
      }
    },

    // apply fiter
    applyFilter() {
      this.loader = true;
      $("#snapdeal-sovdetailedTable").DataTable().destroy();
      this.initCols();
    },

    // change category
    getCategoryList() {
      for (let d of this.viewPlatformAndCategoryData.platform) {
        if (this.selected_website.platform_link == d.platform_link) {
          this.itemCategory =
            this.viewPlatformAndCategoryData.category[d.platform_id];
         
          localStorage.viewPlatformAndCategoryData = JSON.stringify(
            this.viewPlatformAndCategoryData
          );
        }
      }
    },

    updateSelectedLabels(value) {
      return value.platform_name.replaceAll("_", " ");
    },

    getAllStatusByApi() {
      let self = this;
      self.loaderStatus = true;
      const url = "api/v2/sensespiderstatus";
      let payload = {
        timestamp: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        feature: "category",
        feature_id: this.featureId,

      };
      self.$http
        .post(url, payload)
        .then((response) => {
          self.storeAllDataForStatus = response.body.data;
          if (Object.keys(self.storeAllDataForStatus).length) {
            self.$store.dispatch(
              "DemoStore/setUpdatedStatus",
              self.storeAllDataForStatus[self.selected_website.platform_id][
              self.selectedItemCategory.key
              ]
            );
          } else {
            self.$store.dispatch("DemoStore/setUpdatedStatus", "");
          }
          self.loaderStatus = false;
        })
        .catch((err) => {
          console.log(err);
          self.loaderStatus = false;
        });
    },

    // export data
    exportNow() {
      let self = this;
      self.loader = true;
      const url = "/api/v2/india_clinets/sov_detail_download";
      let payload = {
        item_category: this.selectedItemCategory.key,
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        website: this.selected_website.platform_link,
        client: this.customClient,
        data_type: "category",
      };
      this.$http.post(url, payload).then(
        (response) => {
          self.loader = false;
          window.location = response.body.data;
        },
        (err) => {
          self.loader = false;
        }
      );
    },
    initCols() {
      this.columns_details = this.getColumnsDetails;
      this.website_details();
    },
 

    backToSov() {
      this.$router.go(-1);
    },

    format(v) {
      return this.$options.filters.format(v);
    },
    refresh() {
      let self = this;
      this.getCategoryList();
      if (!self.icChangeOccur) {
        this.selectedItemCategory = this.itemCategory[0];
        this.filterCategory = this.itemCategory[0];
      }
      self.icChangeOccur = false;
      // this.initCols();
      // this.handlePlatformSelection();
      // console.log('lll1')
      this.getlastUpdated();
      if (
        Object.keys(this.storeAllDataForStatus).length &&
        this.storeAllDataForStatus[this.selected_website.platform_id]
      ) {
        this.$store.dispatch(
          "DemoStore/setUpdatedStatus",
          this.storeAllDataForStatus[this.selected_website.platform_id][
          this.selectedItemCategory.key
          ]
        );
      } else {
        this.$store.dispatch("DemoStore/setUpdatedStatus", "");
      }
    },

    website_details() {
      let self = this;
      self.loader = true;
      this.rows_details = [];
      this.rows_details_full = [];
      const url = "/api/v2/india_clients/product_website_details";
      let payload = {
        item_category: self.selectedItemCategory.key,
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        website: self.selected_website.platform_link,
        client: self.customClient,
        data_type: "category",
        language: self.$store.state.DemoStore.selectedLanguage.key,
      };
      this.$http.post(url, payload).then(
        (response) => {
          this.sovDetailtableDataShow = response.body.data_present;
          if (response.body.data_present) {
            let plotReadyTable = sortedTable(
              response.body.data.headers,
              response.body.data.data
            );
            this.sovDetailtableDataShow = response.body.data_present;

            this.columns_details = plotReadyTable.plotReadyColumns;
            this.rows_details = plotReadyTable.plotReadyRows;
            this.columnDefs = plotReadyTable.plotReadyColumnDefs;

            // this.columns_details = response.body.data.headers;
            // let resData = response.body.data.data;
            // for (let [idx, ds] of resData.entries()) {
            //   self.rows_details.push(ds);
            //   self.rows_details_full.push(ds);
            // }
            self.loader = false;
            self.$nextTick(function () {
              self.initDt2();
            });
          } else {
            self.loader = false;
          }
        },
        (err) => {
          self.loader = false;
        }
      );
    },

    // changeCustomDate() {
    //   if (this.dateRange.startDate)
    //     this.dateRange.startDate = moment(this.dateRange.startDate).format(
    //       "YYYY-MM-DD"
    //     );
    //   if (this.dateRange.endDate)
    //     this.dateRange.endDate = moment(this.dateRange.endDate).format(
    //       "YYYY-MM-DD"
    //     );
    //   localStorage.philips_startDate = this.dateRange.endDate;
    //   localStorage.philips_prevStartDate = this.dateRange.startDate;
    //   this.icChanged();
    // },
    initDt2() {
      let self = this;
      $("#snapdeal-sovdetailedTable").DataTable({
        language: {
          search: "",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
        columnDefs: this.columnDefs,
        pagingType: "full_numbers",
        initComplete: function () {
          this.api()
            .columns()
            .every(function () {
              var column = this;
              var select = $("<select><option value=''>All</option></select>")
                .appendTo($(column.footer()).empty())
                .on("change", function () {
                  var val = $.fn.dataTable.util.escapeRegex($(this).val());
                  column.search(val ? "^" + val + "$" : "", true, false).draw();
                });
              let arr = [];
              let sortedArr = [];
              column
                .data()
                .unique()
                .sort()
                .each(function (d, j) {
                  var myVal = $(d).text();
                  arr.push(myVal);
                });

              sortedArr = arr.sort((a, b) =>
                a.localeCompare(
                  b,
                  navigator.languages[0] || navigator.language,
                  {
                    numeric: true,
                    ignorePunctuation: true,
                  }
                )
              );
              for (let [idx, ds] of sortedArr.entries()) {
                select.append("<option value='" + ds + "'>" + ds + "</option>");
              }
            });
        },
      });

      $("#snapdeal-sovdetailedTable").wrap(
        "<div style='overflow:auto; width:100%;position:relative;'></div>"
      );

      var search = require("../../../public/Icons_SVG/Search.svg");
      $("#snapdeal-sovdetailedTable_filter > label > input").attr(
        "placeholder",
        "Search"
      );
      $("#snapdeal-sovdetailedTable_filter > label").append(
        `<div class='search_icon'><img src='${search}' width='17'/></div>`
      );
      var btn = $(
        '<input type="button" class="exportButton" value="Export" id="exportBtn"/>'
      );

      $("#snapdeal-sovdetailedTable_filter").append(btn);

      $("#exportBtn").click(function () {
        self.exportNow();
      });

      // $("#snapdeal-sovdetailedTable_filter").prepend(`<div class='filter_icon'><img src='${funnel}' /></div>`);
      // $("#snapdeal-sovdetailedTable_filter > div.filter_icon").click(() => this.filterAddAction())
      $("#snapdeal-sovdetailedTable_length > label > select").removeClass();
    },
  },
};
</script>

<style>
#snapdeal-sovdetailedTable_filter>label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#snapdeal-sovdetailedTable_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#snapdeal-sovdetailedTable_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#snapdeal-sovdetailedTable_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#snapdeal-sovdetailedTable_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#snapdeal-sovdetailedTable_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#snapdeal-sovdetailedTable .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

div#snapdeal-sovdetailedTable_filter {
  display: flex;
  justify-content: end;
}

#snapdeal-sovdetailedTable_filter div.search_icon {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#snapdeal-sovdetailedTable_filter div.search_icon img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

#snapdeal-sovdetailedTable_filter div.filter_icon {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  background-color: var(--background);
}

#snapdeal-sovdetailedTable_filter div.filter_icon img {
  height: 23px;
  filter: brightness(0) saturate(100%) invert(24%) sepia(18%) saturate(2530%) hue-rotate(138deg) brightness(98%) contrast(95%);
}

#snapdeal-sovdetailedTable_paginate {
  position: relative;
  top: 12px;
  z-index: 100;
  float: right;
  width: 50vw;
}

#snapdeal-sovdetailedTable_info {
  position: relative;
  top: 9px;
  left: 0;
  z-index: 100;
  float: none;
  width: auto;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#snapdeal-sovdetailedTable_length {
  /* position: relative;
  top: 90px;
  left: 30px;
  z-index: 100;
  width: 50vw; */
}

#snapdeal-sovdetailedTable_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}

#snapdeal-sovdetailedTable_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#snapdeal-sovdetailedTable_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}

#snapdeal-sovdetailedTable_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}

#snapdeal-sovdetailedTable_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#snapdeal-sovdetailedTable {
  border-radius: 20px 20px 0 0;
}

#snapdeal-sovdetailedTable .thead-normal,
#snapdeal-sovdetailedTable .thead-normal tr,
#snapdeal-sovdetailedTable .thead-normal>tr>th:first-child {
  border-radius: 7px 0 0 0;
  color: #5e5e5e !important;
  border-left: 1px solid var(--base_color-20) !important;
}

#snapdeal-sovdetailedTable .thead-normal>tr>th:last-child {
  border-radius: 0 7px 0 0;
}

#snapdeal-sovdetailedTable .thead-normal>tr>th {
  font-family: "Poppins" !important;
  font-size: 14px !important;
  /* letter-spacing: 0.1px; */
  font-weight: 600 !important;
  text-align: center !important;
  color: black !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  width: 26px !important;
  color: #5e5e5e !important;
}

#snapdeal-sovdetailedTable .thead-normal>tr>th:nth-child(5) {
  width: 300px !important;
}

#snapdeal-sovdetailedTable .thead-normal>tr>th.sorting:before {
  font-size: 15px;
  bottom: 57%;
  color: var(--base_color-80);
  background-color: #f5f5f5 !important;
}

#snapdeal-sovdetailedTable .thead-normal>tr>th.sorting:after {
  /* top: -40%; */
  font-size: 15px;
  color: var(--base_color-80);
  background-color: #fff !important;
}

#snapdeal-sovdetailedTable th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#snapdeal-sovdetailedTable tfoot th {
  background-color: var(--background) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#snapdeal-sovdetailedTable tfoot th:first-child {
  background-color: var(--background) !important;
  border-left: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#snapdeal-sovdetailedTable tbody td {
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  font-family: "Heebo", sans-serif !important;
  color: #5e5e5e !important;
}

#snapdeal-sovdetailedTable tbody td:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#snapdeal-sovdetailedTable .even td {
  /* background: #fff !important; */
}

#snapdeal-sovdetailedTable .odd td {
  /* background: #fff !important; */
  /* filter: brightness(110%); */
}

/* #snapdeal-sovdetailedTable_wrapper .bottom{
  margin: -30px;
} */
#snapdeal-sovdetailedTable_wrapper>.row:last-child {
  margin-bottom: 15px;
  /* margin-left: 20px; */
  margin-left: 0 !important;
}

#snapdeal-sovdetailedTable_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#snapdeal-sovdetailedTable_wrapper .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#snapdeal-sovdetailedTable_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#snapdeal-sovdetailedTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--background);
}

#snapdeal-sovdetailedTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}

#snapdeal-sovdetailedTable_filter .exportButton {
  margin: 0px 10px;
  height: 35px;
  width: 100px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px !important;
  font-weight: 600;
  padding: 0px !important;
  letter-spacing: 0.2px;
}

#snapdeal-sovdetailedTable_filter .exportButton:hover {
  color: white !important;
  background: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.containerOverflowClass {
  width: 100%;
  overflow-x: visible !important;
}

@media screen and (max-width: 768px) {
  #snapdeal-sovdetailedTable_paginate {
    float: none !important;
    width: auto;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
#sovdetail {
  font-family: "Poppins", sans-serif !important;
}

.lastUpdated {
  color: #065559;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 5px 12px;
  border: 1px solid var(--base_color-80);
  border-radius: 6px;
  height: 35px;
  font-weight: 400;
}

.bigger-col {
  width: 50% !important;
}

.SmallBigger-col {
  width: 15%;
}

.checkbox-btn {
  margin-right: 6px;
  height: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  background-color: var(--base_color-10);
  border-radius: 5px;
  color: #000;
  padding: 0px 10px;
}

.checkbox-btn span {
  padding: 0 5px;
}

.checkbox-btn input {
  margin: 4px;
  font-size: 11px;
  width: 15px;
  height: 15px;
  accent-color: #fff;
}

.revampCard {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1.5rem;
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

select {
  font-family: "Poppins", sans-serif;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

button.green {
  background: var(--green);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.green:hover {
  color: white;
  background: var(--green-80);
  /* border: 1.6px solid var(--base_color); */
}

button.red {
  background: var(--red);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.red:hover {
  color: white;
  background: var(--red-80);
  /* border: 1.6px solid var(--base_color); */
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 12px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  margin-bottom: -20px !important;
}

.backIcon {
  filter: brightness(0) saturate(100%) invert(98%) sepia(0%) saturate(206%) hue-rotate(268deg) brightness(116%) contrast(100%);
}

input.textInput {
  border-radius: 5px !important;
  outline: none;
}

input.textInput:focus {
  border-color: var(--primary_brand-60) !important;
  outline: none !important;
  box-shadow: none !important;
}

/* pre-revamp styles */
.custom-table {
  padding: 10px;
  margin: 10px;
}

/* .markitamd {
  background-color: var(--primary_client-20) !important;
} */

.markitintel {
  background-color: #c7e0ff !important;
}

.markitsnap {
  background-color: #ffd0f5 !important;
}

.markitna {
  background-color: #edf2fb !important;
}

.markittek {
  background-color: #fff0ce !important;
}

.space-between-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
  padding-left: 5px;
  padding-right: 7px;
  padding-bottom: 5px;
}

.space-between-header select {
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}

.space-between-header h3 {
  color: #533a79;
  margin-bottom: 0;
  line-height: 31px;
}

.listing-custom {
  font-size: 18px;
  margin-bottom: 6px;
  text-align: center;
  width: 215px;
  background: #8a87e8;
}

.hint {
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
}

.amd-legend {
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index: 999;
}

.amd-legend i {
  width: fit-content;
}

.amd-legend span {
  padding-left: 4px;
  font-size: 12px;
}

.legending {
  display: inline-block;
  margin-right: 19px;
}

#avgTable th,
#avgTable td {
  border: 1px solid #c8ced3 !important;
  text-align: left;
  font-size: 14px;
}

.mycols:first-child {
  padding-right: 2px !important;
}

.mycols:last-child {
  padding-left: 2px;
}

.mycols:not(:first-child):not(:last-child) {
  padding-left: 2px;
  padding-right: 2px;
}
</style>
